import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Modal from '@mui/material/Modal';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DataGridTable from "examples/Tables/DataGridTable";

const ContactDeviceAccessDeviceView = ({ contactName = '', devices, selectedDevices, setSelectedDevices }) => {
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {
            return {
                type: "entity_address_item",
                id: row.address_item_id,
                name: row.name,
                itemName: row.itemName ?? row?.Item?.name,
            };
        });
        return updatedInfo;
    };

    const dataTableAllData = {
        columns: [
            { headerName: "Id", field: "id", flex: 1 },
            { headerName: "Name", field: "name", flex: 1 },
            { headerName: "Item Name", field: "itemName", flex: 1 },
        ],

        rows: getRows(devices),
    };

    const handleOpen = () => {
        setSelectedRows([...selectedDevices]);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const saveHandler = async() => {
        const updatedRows = [...selectedRows];
        setSelectedDevices(updatedRows);
        setSelectedRows(updatedRows)
        setOpen(false);
    }

    return (
        <MDBox display="flex" flexDirection="column" style={{ marginTop: "1rem" }}>
            <MDBox
                display="flex"
            >
                <MDTypography fontWeight="bold">
                    ({contactName}) Contact Access
                </MDTypography>
                <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1rem" }} onClick={handleOpen}>Select Item</MDButton>
            </MDBox>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Card
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '30%', // Set the desired width here
                        backgroundColor: 'white',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    {/* <CardContent> */}
                    <DataGridTable title="Entity Address Item" rowData={getRows(devices)} columns={dataTableAllData.columns} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
                    <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                        <MDButton variant="contained" color="secondary" onClick={handleClose}>
                            Cancel
                        </MDButton>
                        <MDButton variant="contained" color="info" onClick={saveHandler} style={{ marginLeft: '10px' }}>
                            Save
                        </MDButton>
                    </MDBox>
                    {/* </CardContent> */}
                </Card>
            </Modal>
        </MDBox>
    );
};

export default ContactDeviceAccessDeviceView;
